import styled from 'styled-components';
import * as colors from 'components/common/colorConstants';

export const DebugMessageContainer = styled.div`
  display: block;
  margin-top: 4px;
  border: 1px solid ${colors.lightGray21};
  min-height: 29px;
  max-height: 300px;
  white-space: pre-wrap;
  position: relative;
  border-radius: 4px;
  width: 110%;
  overflow-y: auto;

  ::-webkit-scrollbar {
    display: none;
  }
`;

export const DebugMessageCodeBox = styled.div`
  border-radius: 4px;
  background-color: ${colors.lightGray7};
  padding: 8px;
`;
